import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { IContentSearchResult } from '../domain/types/IContentSearchResult';
import { List } from './list/List';
import { ChevronDownIcon, ContentWrap, Css, Responsive } from '../../../ui';
import { ISearchPagination } from '../domain/types/ISearchPagination';
import Button from '../../../components/common/button/Button';

interface IProps {
	results: IContentSearchResult[];
	pagination: ISearchPagination;
	onLoadMore: () => void;
}

export const SearchResults = observer(
	({ results, pagination, onLoadMore }: IProps) => {
		const resultCount = results.length;
		const handleLoadMore = () => {
			onLoadMore();
		};

		return (
			<Wrapper>
				<CountWrapper>
					<ContentWrap>
						<CountTitle>Results [{resultCount}]</CountTitle>
					</ContentWrap>
				</CountWrapper>
				<ListWrapper>
					<ContentWrap>
						<List results={results} />
						{results.length < pagination.nbHits && (
							<ButtonWrapper>
								<Button
									buttonType="secondary"
									icon={<ChevronDownIcon aria-hidden="true" />}
									onClick={handleLoadMore}
								>
									Load more results
								</Button>
							</ButtonWrapper>
						)}
					</ContentWrap>
				</ListWrapper>
			</Wrapper>
		);
	},
);

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-top: ${Css.pxToRem(87)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: ${Css.pxToRem(24)};
	}
`;
const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: stretch;
	justify-content: stretch;
`;

const CountWrapper = styled.div`
	width: 100%;
	margin-top: ${Css.pxToRem(36)};
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: ${Css.pxToRem(40)};
	}
`;

const CountTitle = styled.h4`
	margin: 0 !important;
	font-size: ${Css.pxToRem(32)};
`;

const ListWrapper = styled.div`
	flex: 1;
	padding: 0;
	width: 100%;
	margin-bottom: ${Css.pxToRem(80)};
`;
